export default __webpack_public_path__ + "static/sam-652e566430dc54eca8cf00d39af42ded.jpg";